import React from "react";
import { Navigate } from "react-router-dom";
import { Alert, Container } from "reactstrap";

// "Hakedişlerim" — sürücünün kendi detay sayfasına yönlendirici
const SelfHakedisRedirect = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userId = authUser?.ID;
  const typeId = authUser?.Users_Type_ID;

  if (!userId || (typeId !== 2 && typeId !== 4)) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="danger">Bu sayfa yalnızca sürücü ve çekici hesapları içindir.</Alert>
        </Container>
      </div>
    );
  }

  return <Navigate to={`/surucu-hakedis/${userId}`} replace />;
};

export default SelfHakedisRedirect;
